import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { applyTransaction } from '@datorama/akita';
import { SideMenuStore } from './side-menu.store';
import { MENU_TREE } from './menu.tree';
import { applyVisibility, firstNavigable } from './menu.utils';
import { MenuVisibilityApiService as MenuApi } from './menu.api';
import { co } from '@fullcalendar/core/internal-common';
// import { MenuVisibilityApiMockService as MenuApi } from './menu.api.mock';

@Injectable({ providedIn: 'root' })
export class SideMenuService {
  constructor(
    private store: SideMenuStore,
    private api: MenuApi,
    private router: Router
  ) {}

  /** Public API: App-Start or Login */
  initMenuAndRedirect(): void {
    this.store.update({ loading: true });
    this.api.getVisibility().subscribe({
      next: (map) => {
        const filtered = applyVisibility(MENU_TREE, map);

        applyTransaction(() => {
          this.store.update({ tree: filtered, loading: false });
        });

        const target = firstNavigable(filtered);

        const isAtRoot =
          this.router.url === '/' ||
          this.router.url === '' ||
          this.router.url === '/badge';

        if (isAtRoot && target?.route) {
          this.router.navigateByUrl(target.route);
        }
      },
      error: () => {
        const filtered = applyVisibility(MENU_TREE, {});
        applyTransaction(() => {
          this.store.update({ tree: filtered, loading: false });
        });
        const target = firstNavigable(filtered);

        console.log(target);

        const isAtRoot =
          this.router.url === '/' ||
          this.router.url === '' ||
          this.router.url === '/badge';

        if (isAtRoot && target?.route) {
          this.router.navigateByUrl(target.route);
        }
      },
    });
  }
}
